import React from "react";

import { Box, Grid } from "@material-ui/core";

import AlternateCategoriesSwitch from "./AlternateCategoriesSwitch";
import StoreCategoriesDropdown from "./StoreCategoriesDropdown";

const Filter: React.FC = () => {
    return (
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <StoreCategoriesDropdown />
                </Grid>
            </Grid>
            <Grid container spacing={0}>
                <Grid item xs={12}>
                    <AlternateCategoriesSwitch />
                </Grid>
            </Grid>
        </Box>
    );
};

export default Filter;
